import React from 'react';

import { Button as StyledButton, Wrap, Arrow } from "./styles";


















export const Button = ({
  type = 'button',
  loading,
  onClick = () => void 0,
  style = {},
  children,
  primary,
  centred,
  primaryOutline,
  arrow,
  disabled,
  fullWidth,
  white,
  small,
  arrowWhite }) => /*#__PURE__*/

React.createElement(StyledButton, {
  type: type,
  isLoading: loading,
  centred: centred,
  onClick: loading ? () => void 0 : onClick,
  fullWidth: fullWidth,
  disabled: disabled }, /*#__PURE__*/

React.createElement(Wrap, {
  primary: primary,
  primaryOutline: primaryOutline,
  centred: centred,
  isLoading: loading,
  fullWidth: fullWidth,
  style: style,
  white: white,
  small: small,
  arrowWhite: arrowWhite,
  arrow: arrow }, /*#__PURE__*/

React.createElement(Arrow, { arrow: arrow, arrowWhite: arrowWhite }),
children));